 
/** Auto-generated by scripts/build-apple-perf-index.mjs — do not edit manually. */

import type { PerfProbeLevel } from '../types';

export interface AppleDeviceSpec {
  marketingName: string;
  chip: string;
  ramGb: number;
  maxLevel: PerfProbeLevel;
  formFactor: 'phone' | 'tablet';
}

export interface AppleViewportEntry {
  skus: string[];
  ramGb: number;
  maxLevel: PerfProbeLevel;
}

export const APPLE_DEVICE_SPECS: Record<string, AppleDeviceSpec> = {
  "iPhone18,5": {
    "marketingName": "iPhone 17e",
    "chip": "A19",
    "ramGb": 8,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone18,4": {
    "marketingName": "iPhone Air",
    "chip": "A19 Pro",
    "ramGb": 12,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone18,3": {
    "marketingName": "iPhone 17",
    "chip": "A19",
    "ramGb": 8,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone18,2": {
    "marketingName": "iPhone 17 Pro Max",
    "chip": "A19 Pro",
    "ramGb": 12,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone18,1": {
    "marketingName": "iPhone 17 Pro",
    "chip": "A19 Pro",
    "ramGb": 12,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone17,5": {
    "marketingName": "iPhone 16e",
    "chip": "A18",
    "ramGb": 8,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone17,4": {
    "marketingName": "iPhone 16 Plus",
    "chip": "A18",
    "ramGb": 8,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone17,3": {
    "marketingName": "iPhone 16",
    "chip": "A18",
    "ramGb": 8,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone17,2": {
    "marketingName": "iPhone 16 Pro Max",
    "chip": "A18 Pro",
    "ramGb": 8,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone17,1": {
    "marketingName": "iPhone 16 Pro",
    "chip": "A18 Pro",
    "ramGb": 8,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone16,2": {
    "marketingName": "iPhone 15 Pro Max",
    "chip": "A17 Pro",
    "ramGb": 8,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone16,1": {
    "marketingName": "iPhone 15 Pro",
    "chip": "A17 Pro",
    "ramGb": 8,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone15,5": {
    "marketingName": "iPhone 15 Plus",
    "chip": "A16",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone15,4": {
    "marketingName": "iPhone 15",
    "chip": "A16",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone15,3": {
    "marketingName": "iPhone 14 Pro Max",
    "chip": "A16",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone15,2": {
    "marketingName": "iPhone 14 Pro",
    "chip": "A16",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone14,8": {
    "marketingName": "iPhone 14 Plus",
    "chip": "A15",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone14,7": {
    "marketingName": "iPhone 14",
    "chip": "A15",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone14,6": {
    "marketingName": "iPhone SE (3rd generation)",
    "chip": "A15",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "phone"
  },
  "iPhone14,5": {
    "marketingName": "iPhone 13",
    "chip": "A15",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "phone"
  },
  "iPhone14,4": {
    "marketingName": "iPhone 13 mini",
    "chip": "A15",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "phone"
  },
  "iPhone14,3": {
    "marketingName": "iPhone 13 Pro Max",
    "chip": "A15",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone14,2": {
    "marketingName": "iPhone 13 Pro",
    "chip": "A15",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone13,4": {
    "marketingName": "iPhone 12 Pro Max",
    "chip": "A14",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone13,3": {
    "marketingName": "iPhone 12 Pro",
    "chip": "A14",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "phone"
  },
  "iPhone13,2": {
    "marketingName": "iPhone 12",
    "chip": "A14",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "phone"
  },
  "iPhone13,1": {
    "marketingName": "iPhone 12 mini",
    "chip": "A14",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "phone"
  },
  "iPhone12,8": {
    "marketingName": "iPhone SE (2nd generation)",
    "chip": "A13",
    "ramGb": 3,
    "maxLevel": "low",
    "formFactor": "phone"
  },
  "iPhone12,5": {
    "marketingName": "iPhone 11 Pro Max",
    "chip": "A13",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "phone"
  },
  "iPhone12,3": {
    "marketingName": "iPhone 11 Pro",
    "chip": "A13",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "phone"
  },
  "iPhone12,1": {
    "marketingName": "iPhone 11",
    "chip": "A13",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "phone"
  },
  "iPhone11,8": {
    "marketingName": "iPhone XR",
    "chip": "A12",
    "ramGb": 3,
    "maxLevel": "low",
    "formFactor": "phone"
  },
  "iPhone11,4": {
    "marketingName": "iPhone XS Max",
    "chip": "A12",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "phone"
  },
  "iPhone11,2": {
    "marketingName": "iPhone XS",
    "chip": "A12",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "phone"
  },
  "iPad17,1": {
    "marketingName": "iPad Pro 11-inch (M5)",
    "chip": "M5",
    "ramGb": 12,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad17,2": {
    "marketingName": "iPad Pro 11-inch (M5)",
    "chip": "M5",
    "ramGb": 12,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad17,3": {
    "marketingName": "iPad Pro 13-inch (M5)",
    "chip": "M5",
    "ramGb": 12,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad17,4": {
    "marketingName": "iPad Pro 13-inch (M5)",
    "chip": "M5",
    "ramGb": 12,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad16,10": {
    "marketingName": "iPad Air 13-inch (M4)",
    "chip": "M4",
    "ramGb": 12,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad16,11": {
    "marketingName": "iPad Air 13-inch (M4)",
    "chip": "M4",
    "ramGb": 12,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad16,8": {
    "marketingName": "iPad Air 11-inch (M4)",
    "chip": "M4",
    "ramGb": 12,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad16,9": {
    "marketingName": "iPad Air 11-inch (M4)",
    "chip": "M4",
    "ramGb": 12,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad16,5": {
    "marketingName": "iPad Pro 13-inch (M4)",
    "chip": "M4",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad16,6": {
    "marketingName": "iPad Pro 13-inch (M4)",
    "chip": "M4",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad16,3": {
    "marketingName": "iPad Pro 11-inch (M4)",
    "chip": "M4",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad16,4": {
    "marketingName": "iPad Pro 11-inch (M4)",
    "chip": "M4",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad16,1": {
    "marketingName": "iPad mini (A17 Pro)",
    "chip": "A17 Pro",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad16,2": {
    "marketingName": "iPad mini (A17 Pro)",
    "chip": "A17 Pro",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad15,7": {
    "marketingName": "iPad (A16)",
    "chip": "A16",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad15,8": {
    "marketingName": "iPad (A16)",
    "chip": "A16",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad15,5": {
    "marketingName": "iPad Air 13-inch (M3)",
    "chip": "M3",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad15,6": {
    "marketingName": "iPad Air 13-inch (M3)",
    "chip": "M3",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad15,3": {
    "marketingName": "iPad Air 11-inch (M3)",
    "chip": "M3",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad15,4": {
    "marketingName": "iPad Air 11-inch (M3)",
    "chip": "M3",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad14,8": {
    "marketingName": "iPad Air 11-inch (M2)",
    "chip": "M2",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad14,9": {
    "marketingName": "iPad Air 11-inch (M2)",
    "chip": "M2",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad14,5": {
    "marketingName": "iPad Pro (12.9-inch) (6th generation)",
    "chip": "M2",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad14,6": {
    "marketingName": "iPad Pro (12.9-inch) (6th generation)",
    "chip": "M2",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad14,3": {
    "marketingName": "iPad Pro (11-inch) (4th generation)",
    "chip": "M2",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad14,4": {
    "marketingName": "iPad Pro (11-inch) (4th generation)",
    "chip": "M2",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad14,1": {
    "marketingName": "iPad mini (6th generation)",
    "chip": "A15",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad14,2": {
    "marketingName": "iPad mini (6th generation)",
    "chip": "A15",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad14,10": {
    "marketingName": "iPad Air 13-inch (M2)",
    "chip": "M2",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad14,11": {
    "marketingName": "iPad Air 13-inch (M2)",
    "chip": "M2",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad13,8": {
    "marketingName": "iPad Pro (12.9-inch) (5th generation)",
    "chip": "M1",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad13,9": {
    "marketingName": "iPad Pro (12.9-inch) (5th generation)",
    "chip": "M1",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad13,10": {
    "marketingName": "iPad Pro (12.9-inch) (5th generation)",
    "chip": "M1",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad13,11": {
    "marketingName": "iPad Pro (12.9-inch) (5th generation)",
    "chip": "M1",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad13,4": {
    "marketingName": "iPad Pro (11-inch) (3rd generation)",
    "chip": "M1",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad13,5": {
    "marketingName": "iPad Pro (11-inch) (3rd generation)",
    "chip": "M1",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad13,6": {
    "marketingName": "iPad Pro (11-inch) (3rd generation)",
    "chip": "M1",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad13,7": {
    "marketingName": "iPad Pro (11-inch) (3rd generation)",
    "chip": "M1",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad13,1": {
    "marketingName": "iPad Air (4th generation)",
    "chip": "A14",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad13,2": {
    "marketingName": "iPad Air (4th generation)",
    "chip": "A14",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad13,18": {
    "marketingName": "iPad (10th generation)",
    "chip": "A14",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad13,19": {
    "marketingName": "iPad (10th generation)",
    "chip": "A14",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad13,16": {
    "marketingName": "iPad Air (5th generation)",
    "chip": "M1",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad13,17": {
    "marketingName": "iPad Air (5th generation)",
    "chip": "M1",
    "ramGb": 8,
    "maxLevel": "high",
    "formFactor": "tablet"
  },
  "iPad12,1": {
    "marketingName": "iPad (9th generation)",
    "chip": "A13",
    "ramGb": 3,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad12,2": {
    "marketingName": "iPad (9th generation)",
    "chip": "A13",
    "ramGb": 3,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad11,6": {
    "marketingName": "iPad (8th generation)",
    "chip": "A12",
    "ramGb": 3,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad11,7": {
    "marketingName": "iPad (8th generation)",
    "chip": "A12",
    "ramGb": 3,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad11,3": {
    "marketingName": "iPad Air (3rd generation)",
    "chip": "A12",
    "ramGb": 3,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad11,4": {
    "marketingName": "iPad Air (3rd generation)",
    "chip": "A12",
    "ramGb": 3,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad11,1": {
    "marketingName": "iPad mini (5th generation)",
    "chip": "A12",
    "ramGb": 3,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad11,2": {
    "marketingName": "iPad mini (5th generation)",
    "chip": "A12",
    "ramGb": 3,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad8,9": {
    "marketingName": "iPad Pro (11-inch) (2nd generation)",
    "chip": "A12Z",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "tablet"
  },
  "iPad8,10": {
    "marketingName": "iPad Pro (11-inch) (2nd generation)",
    "chip": "A12Z",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "tablet"
  },
  "iPad8,11": {
    "marketingName": "iPad Pro (12.9-inch) (4th generation)",
    "chip": "A12Z",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "tablet"
  },
  "iPad8,12": {
    "marketingName": "iPad Pro (12.9-inch) (4th generation)",
    "chip": "A12Z",
    "ramGb": 6,
    "maxLevel": "medium",
    "formFactor": "tablet"
  },
  "iPad8,5": {
    "marketingName": "iPad Pro (12.9-inch) (3rd generation)",
    "chip": "A12X",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad8,6": {
    "marketingName": "iPad Pro (12.9-inch) (3rd generation)",
    "chip": "A12X",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad8,7": {
    "marketingName": "iPad Pro (12.9-inch) (3rd generation)",
    "chip": "A12X",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad8,8": {
    "marketingName": "iPad Pro (12.9-inch) (3rd generation)",
    "chip": "A12X",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad8,1": {
    "marketingName": "iPad Pro (11-inch)",
    "chip": "A12X",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad8,2": {
    "marketingName": "iPad Pro (11-inch)",
    "chip": "A12X",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad8,3": {
    "marketingName": "iPad Pro (11-inch)",
    "chip": "A12X",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  },
  "iPad8,4": {
    "marketingName": "iPad Pro (11-inch)",
    "chip": "A12X",
    "ramGb": 4,
    "maxLevel": "low",
    "formFactor": "tablet"
  }
};

export const APPLE_VIEWPORT_INDEX: Record<string, AppleViewportEntry> = {
  "375x667@2": {
    "skus": [
      "iPhone12,8",
      "iPhone14,6"
    ],
    "ramGb": 3,
    "maxLevel": "low"
  },
  "375x812@3": {
    "skus": [
      "iPhone12,3",
      "iPhone12,5",
      "iPhone13,1",
      "iPhone14,4"
    ],
    "ramGb": 4,
    "maxLevel": "low"
  },
  "390x844@3": {
    "skus": [
      "iPhone13,2",
      "iPhone14,5",
      "iPhone14,7",
      "iPhone14,8"
    ],
    "ramGb": 4,
    "maxLevel": "low"
  },
  "393x852@3": {
    "skus": [
      "iPhone15,4",
      "iPhone17,3"
    ],
    "ramGb": 6,
    "maxLevel": "medium"
  },
  "402x874@3": {
    "skus": [
      "iPhone16,1",
      "iPhone17,1",
      "iPhone17,2"
    ],
    "ramGb": 8,
    "maxLevel": "medium"
  },
  "414x896@2": {
    "skus": [
      "iPhone11,8",
      "iPhone12,1"
    ],
    "ramGb": 3,
    "maxLevel": "low"
  },
  "414x896@3": {
    "skus": [
      "iPhone11,2",
      "iPhone11,4",
      "iPhone12,3",
      "iPhone12,5"
    ],
    "ramGb": 4,
    "maxLevel": "low"
  },
  "428x926@3": {
    "skus": [
      "iPhone13,4",
      "iPhone14,8",
      "iPhone15,5",
      "iPhone17,4"
    ],
    "ramGb": 6,
    "maxLevel": "medium"
  },
  "430x932@3": {
    "skus": [
      "iPhone14,3",
      "iPhone15,3",
      "iPhone16,2",
      "iPhone17,2"
    ],
    "ramGb": 6,
    "maxLevel": "medium"
  },
  "440x956@3": {
    "skus": [
      "iPhone16,2",
      "iPhone17,2"
    ],
    "ramGb": 8,
    "maxLevel": "medium"
  },
  "744x1133@2": {
    "skus": [
      "iPad14,1",
      "iPad14,2",
      "iPad16,1",
      "iPad16,2"
    ],
    "ramGb": 4,
    "maxLevel": "low"
  },
  "768x1024@2": {
    "skus": [
      "iPad11,6",
      "iPad11,7",
      "iPad12,1",
      "iPad12,2"
    ],
    "ramGb": 3,
    "maxLevel": "low"
  },
  "810x1080@2": {
    "skus": [
      "iPad13,18",
      "iPad13,19",
      "iPad15,7",
      "iPad15,8"
    ],
    "ramGb": 4,
    "maxLevel": "low"
  },
  "820x1180@2": {
    "skus": [
      "iPad13,1",
      "iPad13,2",
      "iPad14,8",
      "iPad14,9",
      "iPad15,3",
      "iPad15,4",
      "iPad16,8",
      "iPad16,9"
    ],
    "ramGb": 4,
    "maxLevel": "low"
  },
  "834x1112@2": {
    "skus": [
      "iPad11,3",
      "iPad11,4",
      "iPad8,1",
      "iPad8,2",
      "iPad8,3",
      "iPad8,4"
    ],
    "ramGb": 3,
    "maxLevel": "low"
  },
  "834x1194@2": {
    "skus": [
      "iPad8,9",
      "iPad8,10",
      "iPad13,4",
      "iPad13,5",
      "iPad13,6",
      "iPad13,7",
      "iPad14,3",
      "iPad14,4",
      "iPad16,3",
      "iPad16,4",
      "iPad17,1",
      "iPad17,2"
    ],
    "ramGb": 6,
    "maxLevel": "medium"
  },
  "1024x1366@2": {
    "skus": [
      "iPad8,5",
      "iPad8,6",
      "iPad8,7",
      "iPad8,8",
      "iPad8,11",
      "iPad8,12",
      "iPad13,8",
      "iPad13,9",
      "iPad13,10",
      "iPad13,11",
      "iPad14,5",
      "iPad14,6",
      "iPad16,5",
      "iPad16,6",
      "iPad17,3",
      "iPad17,4"
    ],
    "ramGb": 4,
    "maxLevel": "low"
  },
  "1032x1376@2": {
    "skus": [
      "iPad14,10",
      "iPad14,11",
      "iPad15,5",
      "iPad15,6",
      "iPad16,10",
      "iPad16,11"
    ],
    "ramGb": 8,
    "maxLevel": "high"
  }
};
